export const GET_ALL_CITIES = "GET_ALL_CITIES";
export const EDIT_CITY = "EDIT_CITY";
export const GET_CITY_USERS = "GET_CITY_USERS";

//messages
export const GET_ALL_MESSAGES = "GET_ALL_MESSAGES";
export const GET_CITY_WAREHOUSE = "GET_CITY_WAREHOUSE";
